import { render, staticRenderFns } from "./RecruiterStatus.vue?vue&type=template&id=33a243fc"
import script from "./RecruiterStatus.vue?vue&type=script&lang=js"
export * from "./RecruiterStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports